<template>
    <div class="stepMenu">
    <ul class="horizontal-list ">
      <li class="item" v-for="( item, index ) in menu_list" :key="index">
        <router-link :to="item.name" active-class="active" @click="clickMenu( index )">{{ index + 1 }}.{{ item.title }}</router-link>
      </li>
    </ul>
  </div>
  <div class=" CfgStep__container">
    <div>
      <button class="btn btn_back" @click="clickMenu( menu_back ,'back')" :disabled="(menu_back==-1) ? true : false">戻る</button>
    </div>
    <div class="stepMenuPc">
      <ul class="horizontal-list ">
        <li class="item" v-for="( item, index ) in menu_list" :key="index">
          <router-link :to="item.name" active-class="active" @click="clickMenu( index , 'menu')">{{ index + 1 }}.{{ item.title }}</router-link>
        </li>
      </ul>
    </div>
    <div>
      <button class="btn btn_next" @click="clickMenu( menu_next , 'next')" :disabled="(menu_next==-1) ? true : false">次へ</button>
    </div>
  </div>
</template>

<script>
import { props, context, inject, reactive, ref } from "vue";
import RjConfiguration from "../functions/RjConfiguration"


export default {
  name: "StepMenu",
  components: {
  },
  setup(props, context) {
    const RJ = RjConfiguration()
    const menu_list = RJ.getMenuList()
    //ブラウザバック時詰め直し
    RJ.getUrlFromPathName();
    const menu_index = RJ.getMenuActiveIndex()
    const menu_name = RJ.getMenuActive().name


    const clickMenu = ( no , type ) => {
      let menu_no = no

      if(menu_name==="option"){
        const optionTab = RJ.getOptionMode()
        const optionTabList = RJ.getOptionTabList();
        const tab_count = optionTabList.length;
        const tab_index = optionTabList.indexOf(optionTab);
        if(type==="next" && tab_index < tab_count-1){
          context.emit('clickOptionTab',optionTabList[tab_index+1])
          return
        }else if(type==="back" && tab_index > 0){
          context.emit('clickOptionTab',optionTabList[tab_index-1])
          return
        }
      }

      RJ.gotoMenu( menu_no )
    };
    let menu_back = -1
    let menu_next = -1
    if(menu_index < menu_list.length-1){
      menu_next = menu_index + 1
    }
    if(menu_index > 0){
      menu_back = menu_index-1
    }

    return {
      menu_index,
      menu_list,
      menu_next,
      menu_back,
      clickMenu,
    };
  },

};
</script>

<style scoped>
button:disabled {
  color: #8c8c8b;
  background-color: #D9D9D6;
}
</style>
